import { useEffect } from 'react';

export default function (isHidden: boolean) {
  useEffect(() => {
    if (isHidden) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isHidden]);
}
